import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 22 26"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.464 6.769h1.605v1.31c.001.677.484 1.227 1.081 1.228h2.304c.597-.001 1.08-.551 1.082-1.229v-1.31h4.93v1.31c.002.678.484 1.228 1.08 1.229h2.306c.595-.002 1.078-.551 1.08-1.229v-1.31h1.604c.199.002.361.185.362.413v2.693H2.101V7.18c.001-.228.163-.412.363-.412Zm3.35-2.538v3.091h.974V4.231h-.974Zm9.398 0v3.091h.974V4.231h-.974Zm4.324 17.538H2.464c-.2 0-.362-.183-.363-.41v-9.5H19.9v9.5c-.001.227-.163.41-.363.41ZM2.464 23.756h17.072c1.164-.002 2.108-1.074 2.11-2.397V7.181c-.002-1.324-.945-2.397-2.11-2.398h-1.605v-1.31c0-.677-.484-1.226-1.08-1.228h-2.304c-.597.002-1.08.55-1.081 1.229v1.31H8.535v-1.31c-.002-.678-.485-1.227-1.082-1.229H5.15c-.597.002-1.08.55-1.08 1.229v1.31H2.463C1.299 4.783.356 5.856.355 7.18v14.177c.002 1.323.945 2.395 2.109 2.397Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }